// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.AboutDoctor_doctor__yo0mH {
  padding: 0;
}
.AboutDoctor_doctor__yo0mH .AboutDoctor_container__z2Uu0 {
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1400px;
  margin: 0 auto;
}
.AboutDoctor_doctor__yo0mH .AboutDoctor_imageWrapper__03\\+4j {
  flex: 1 1;
  min-width: 300px;
}
.AboutDoctor_doctor__yo0mH .AboutDoctor_imageWrapper__03\\+4j img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 20px;
}
.AboutDoctor_doctor__yo0mH .AboutDoctor_textWrapper__8W\\+Vv {
  flex: 1 1;
  background: #2C4190; /* 🔹 քո նշած գույնը */
  color: #fff;
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.AboutDoctor_doctor__yo0mH .AboutDoctor_textWrapper__8W\\+Vv h3 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 20px;
}
.AboutDoctor_doctor__yo0mH .AboutDoctor_textWrapper__8W\\+Vv p {
  font-size: 1rem;
  line-height: 1.8;
  color: #f0f0f0;
}
@media (max-width: 900px) {
  .AboutDoctor_doctor__yo0mH .AboutDoctor_container__z2Uu0 {
    flex-direction: column;
  }
  .AboutDoctor_doctor__yo0mH .AboutDoctor_textWrapper__8W\\+Vv {
    padding: 40px 20px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleAboutUs/AboutDoctor.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,UAAA;AAEF;AAAE;EACE,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAEJ;AACE;EACE,SAAA;EACA,gBAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAEN;AAEE;EACE,SAAA;EACA,mBAAA,EAAA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAAN;AAGI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADN;AAKE;EACE;IACE,sBAAA;EAHJ;EAKE;IACE,kBAAA;IACA,kBAAA;EAHJ;AACF","sourcesContent":[".doctor {\r\n  padding: 0;\r\n\r\n  .container {\r\n    display: flex;\r\n    align-items: stretch;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .imageWrapper {\r\n    flex: 1;\r\n    min-width: 300px;\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: cover;\r\n      display: block;\r\n      border-radius: 20px;\r\n    }\r\n  }\r\n\r\n  .textWrapper {\r\n    flex: 1;\r\n    background: #2C4190; /* 🔹 քո նշած գույնը */\r\n    color: #fff;\r\n    padding: 60px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n\r\n    h3 {\r\n      font-size: 1.8rem;\r\n      font-weight: 700;\r\n      margin-bottom: 20px;\r\n    }\r\n\r\n    p {\r\n      font-size: 1rem;\r\n      line-height: 1.8;\r\n      color: #f0f0f0;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 900px) {\r\n    .container {\r\n      flex-direction: column;\r\n    }\r\n    .textWrapper {\r\n      padding: 40px 20px;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"doctor": `AboutDoctor_doctor__yo0mH`,
	"container": `AboutDoctor_container__z2Uu0`,
	"imageWrapper": `AboutDoctor_imageWrapper__03+4j`,
	"textWrapper": `AboutDoctor_textWrapper__8W+Vv`
};
export default ___CSS_LOADER_EXPORT___;
